import { customAlphabet } from 'nanoid';

const REFERENCE_LENGTH = 12;
const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', REFERENCE_LENGTH);

export const generateReference = (): string => {
  return `VOTE_${nanoid()}`;
};